import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../../locales/useTranslations';

const MailServerCta = () => {
  const { t } = useTranslations();

  return (
    <section className="ms-cta">
      <div className="container">
        <h2 className="ms-cta__title">{t('managedServices_mailServer_cta_title')}</h2>
        <p className="ms-cta__text">{t('managedServices_mailServer_cta_description')}</p>
        <Link href="/kontakt/" className="ms-header__btn-primary">
          {t('managedServices_mailServer_cta_button')}
        </Link>
      </div>
    </section>
  );
};

export default MailServerCta;
